module.exports = __webpack_public_path__ + "static/media/160421-GlobalNavIA_v5.005.d7a57f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160421-GlobalNavIA_v5/160421-GlobalNavIA_v5.005.png
// module id = 199
// module chunks = 0